import { render, staticRenderFns } from "./CustomerBugDetails.vue?vue&type=template&id=aa6be698&scoped=true&"
import script from "./CustomerBugDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerBugDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBugDetails.vue?vue&type=style&index=0&id=aa6be698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6be698",
  null
  
)

export default component.exports